export const ORIENTATION_VERTICAL = 'vertical';
export const ORIENTATION_HORIZONTAL = 'horizontal';

export type OrientationType = typeof ORIENTATION_VERTICAL | typeof ORIENTATION_HORIZONTAL;
